import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "./api";

const Ctx = createContext(null);

export function MemberProvider({ children }) {
  const [member, setMember] = useState(null); // null = checking, false = logged out
  const [meta, setMeta] = useState(null);
  const reload = useCallback(async () => {
    try { setMember((await api("/auth/me")).member); } catch (e) {
      if (e.status === 401 && (await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/training/auth/refresh`, { method: "POST", credentials: "include" })).ok) {
        try { setMember((await api("/auth/me")).member); return; } catch (_) { /* fallthrough */ }
      }
      setMember(false);
    }
  }, []);
  useEffect(() => { reload(); api("/meta").then(setMeta).catch(() => {}); }, [reload]);
  const logout = async () => { navigator.serviceWorker?.controller?.postMessage({ type: "clear" }); await api("/auth/logout", { method: "POST" }).catch(() => {}); setMember(false); };
  return <Ctx.Provider value={{ member, setMember, meta, reload, logout }}>{children}</Ctx.Provider>;
}

export const useMember = () => useContext(Ctx);

export const label = (meta, group, id) => meta?.[group]?.find((x) => x.id === id)?.label || id;
